import React from 'react';

const CakeCategory = ({ onSelectCategory, selectedCategory, categories }) => {
  return (
    <div className="container mx-auto px-4 sm:px-8 md:px-12 lg:px-20 xl:px-24 2xl:px-32 mt-8 mb-12">
      <div className="bg-gray-200 py-4 px-6 rounded-lg">
        <p className="md:text-3xl text-1xl font-bold text-amber-600 mb-4">Explore Cakes</p>
        <div className="grid grid-cols-3 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
          <button
            key="All"
            className={`text-1xl md:text-lg text-amber-600 font-semibold ${
              selectedCategory === 'All' ? 'border-b-2 border-amber-600' : ''
            }`}
            onClick={() => onSelectCategory('All')}
          >
            All
          </button>
          {categories.map((category) => (
            <button
              key={category}
              className={`text-1xl md:text-lg text-amber-600 font-semibold ${
                selectedCategory === category ? 'border-b-2 border-amber-600' : ''
              }`}
              onClick={() => onSelectCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CakeCategory;
